import api from "./api";
import { createQueryParams } from "../Helpers/QueryParams";

export interface clientData {
    name: string,
    email_address: string,
    address: string,
    country: string,
    properties?: any
}

export interface propertyData {
    name: string,
    contact_name: string,
    email_address: string,
    address: string,
}

export interface meterData {
    name: string,
    meter_type: string,
    meter_number: string,
    location: string,
    utility_id: string,
    Si_unit: string,
    site_id: string,
    images: any
}

export const getDashboard = async (company_id: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const response = await api.get(`/client/dashboard?company_id=${company_id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getDashboardData = async (company_id: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const response = await api.get(`/client/dashboard-data?company_id=${company_id}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getBillsData = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        if (!token) {
            throw new Error("No token found, please log in.");
        }

        const queryParams = createQueryParams(params);
        const response = await api.get(`/client/bill-data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getProperties = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/properties`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getProperty = async (propertyId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/properties/${propertyId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getPropertyUtilities = async (propertyId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/properties/${propertyId}/utilities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getUtilities = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/bills/utilities`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Utility Suppliers");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getUtility = async (utilityId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/bills/utilities/${utilityId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Utility Suppliers");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getPropertyUtilityMeters = async (propertyId: string, utilityId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/properties/${propertyId}/utilities/${utilityId}/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getMeters = async (): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/meters`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Clients");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getBills = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/client/bills?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

export const getBillById = async (billId: string): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const response = await api.get(`/client/bills/${billId}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Bill");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
}

// ${url}/clients/energy/graph-data?
export const getTrackerChart = async (params: any): Promise<any> => {
    try {
        const token: string | null = localStorage.getItem("token"); // Get token from localStorage

        const queryParams = createQueryParams(params);
        const response = await api.get(`/client/energy/graph-data?${queryParams.toString()}`, {
            headers: {
                Authorization: `Bearer ${token}`, // Attach token to headers
            },
        });

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Chart Data");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};